import { mapActiveInactiveStatusEnumToItemLabelModel } from '../../../../shared/utils/mapping/mapping.util';
import { BasicInfoFormikModel } from '../../components/campaign-basic-info/models/basic-info-formik.model';
import { CampaignResponseModel } from '../../models/campaign-response.model';

export const basicInfoResponseModelToFormik = (
  data: CampaignResponseModel
): BasicInfoFormikModel => ({
  name: data.name,
  startDate: new Date(data.startDate),
  endDate: new Date(data.endDate),
  wifiExpirationDate: new Date(data.wifiExpirationDate),
  fotaUpdateType: data.fotaUpdateType,
  serverInitiatedType: data.serverInitiatedType,
  safetyRelevant: data.safetyRelevant,
  description: data.description,
  maxRetryNo: data.maxRetryNo,
  is5GDownloadingAllowed: data.is5GDownloadingAllowed,
  version: data.version,
  firmwareIds: data.firmwares.map(firmware => firmware.id),
  status: mapActiveInactiveStatusEnumToItemLabelModel(data.status),
});
